export const CURRENCY_MAX_9_DIGIT_PATTERN = /^\d{0,9}(\.\d{0,2})?$/
export const CURRENCY_MAX_6_DIGIT_PATTERN = /^\d{0,6}(\.\d{0,2})?$/
export const CURRENCY_MAX_5_DIGIT_PATTERN = /^\d{0,5}(\.\d{0,2})?$/
export const CURRENCY_MIN_1_DIGIT_PATTERN = /^\d+(\.\d{0,2})?$/
export const PERCENTAGE_PATTERN = /^\d{0,3}(\.\d{0,2})?$/
export const INTEGER_PATTERN = /^\d+$/
